import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import { up } from 'styled-breakpoints';
import BodyText from '@fenderdigital/ui/BodyText';
import Flex from '@fenderdigital/ui/Flex';
import { Check } from '@fenderdigital/ui/Icons';
import messages from './messages';

interface OffPathVideoEndCardProps {
  currentVideoTitle?: string;
  currentVideoType?: string;
  dataId?: string;
}

const VideoTitle = styled.span`
  font-family: ${({ theme }): string => theme.fonts.futuraHeavy};
`;

const OffPathVideoEndCard: FC<OffPathVideoEndCardProps> = ({
  currentVideoTitle = '',
  currentVideoType = 'course',
  dataId = 'end-card',
}) => {
  return (
    <Flex data-id={`${dataId}-complete`} align="center" justify="center" height="100%">
      <Flex
        css={css`
          padding: 0 ${({ theme }): string => theme.spacing.md2};

          ${up('tablet-landscape')} {
            align-items: center;
          }
        `}
      >
        <Flex
          css={css`
            ${up('tablet-landscape')} {
              margin-top: -${({ theme }): string => theme.spacing.sm3};
            }
          `}
        >
          <Check
            aria-hidden
            css={css`
              fill: ${({ theme }): string => theme.colors.success};
              font-size: ${({ theme }): string => theme.fontSizes.f4};
              padding-right: ${({ theme }): string => theme.spacing.sm2};

              @media screen and (min-width: 30em) {
                font-size: ${({ theme }): string => theme.fontSizes.f5};
              }
            `}
          />
        </Flex>
        <BodyText
          alignment="left"
          textSize="f3"
          textColor="white"
          css={css`
            font-family: ${({ theme }): string => theme.fonts.futuraBook};

            @media screen and (min-width: 30em) {
              font-size: 1.25rem;
            }
          `}
        >
          <FormattedMessage
            {...messages.completedVideoMessage}
            values={{
              type: currentVideoType,
              video: <VideoTitle>{currentVideoTitle}</VideoTitle>,
            }}
          />
        </BodyText>
      </Flex>
    </Flex>
  );
};

export default OffPathVideoEndCard;
